import { Spinner } from '@creditornot/cb-ingredients';
import { AuthStatus } from '@creditornot/wolt-auth';
import { useAuthState } from '@creditornot/wolt-auth/react';
import React, { ReactElement } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import styled from 'styled-components';

const LoadingSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-block-start: 40px;
  padding-block-end: 40px;
`;

const Loading = () => (
  <LoadingSpinnerContainer>
    <Spinner size="large" />
  </LoadingSpinnerContainer>
);

/**
 * Page can only be shown if the user is logged out, otherwise redirects to the home page
 */
const RouteWhenNotAuthenticated = (props: RouteProps) => {
  const { status } = useAuthState();

  const statusMap: Record<AuthStatus, () => ReactElement> = {
    'logged-in': () => <Redirect to="/" />,
    'logging-in': () => <Loading />,
    'logged-out': () => <Route {...props} />,
  };

  return statusMap[status]();
};

export default RouteWhenNotAuthenticated;
